import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { uploadMaterialBill,fetchMaterialDetails } from '../../../../../../../Redux/Projects/Material/materialSlice';
import '../../../../../../../Stylesheets/Dashboard/Tabs/Materials/UploadBillModal.css';
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { storage } from '../../../../../../../firebase';
import imageCompression from 'browser-image-compression';
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';

const UploadBillModal = ({ material = {}, projectId, onClose }) => {

  console.log('📦 UploadBillModal Loaded:', material);


  const dispatch = useDispatch();

  const [amount, setAmount] = useState('');
  const [quantity, setQuantity] = useState('');
  const [file, setFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const isSkipQuantity = material?.skipQuantityInBill;

  useEffect(() => {
    if (isSkipQuantity) {
      setQuantity(material?.quantityToBill?.toString() || '');
    }
  }, [material]);


  const isFormValid = () => {
    const amt = parseFloat(amount);
    const qty = isSkipQuantity ? parseFloat(material?.quantityToBill || 0) : parseFloat(quantity);
    return amt > 0 && (!isNaN(qty) && qty > 0) && file;
  };


  const handleSubmit = async () => {
    const parsedAmount = parseFloat(amount);
    const parsedQty = isSkipQuantity
      ? parseFloat(material?.quantityToBill || 0)
      : parseFloat(quantity);

    if (!parsedAmount || isNaN(parsedAmount) || parsedAmount <= 0) {
      toast.error('⚠️ Please enter a valid amount');
      return;
    }

    if (!isSkipQuantity && (!parsedQty || isNaN(parsedQty) || parsedQty <= 0)) {
      toast.error('⚠️ Please enter a valid quantity');
      return;
    }

    if (!file) {
      toast.error('⚠️ Please select a file to upload');
      return;
    }

    setSubmitting(true);

    try {
      let uploadFile = file;

      // Compress image files before upload
      if (file.type.startsWith('image/')) {
        uploadFile = await imageCompression(file, {
          maxSizeMB: 0.6,
          maxWidthOrHeight: 1500,
          useWebWorker: true,
        });
      }

      const fileRef = ref(storage, `material-bills/${uuidv4()}-${file.name}`);
      await uploadBytes(fileRef, uploadFile);
      const fileUrl = await getDownloadURL(fileRef);

      const payload = {
        materialId: material._id || material.id,
        projectId, // ✅ Critical for controller
        quantity: parsedQty,
        amount: parsedAmount,
        fileUrl,
        date: new Date().toISOString(),
      };

      console.log('Uploading bill with payload:', payload);
      const res = await dispatch(uploadMaterialBill(payload));
      if (res.meta.requestStatus === 'fulfilled') {
        // dispatch(fetchMaterialsByProject(projectId));
        dispatch(fetchMaterialDetails(material._id));

        toast.success('✅ Bill uploaded successfully!');
        onClose();
      } else {
        console.log(res.payload?.message)
        toast.error(res.payload?.message || '❌ Failed to upload bill.');
      }
    } catch (err) {
      console.error('Bill upload error:', err);
      toast.error('Something went wrong while uploading the bill.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="material-tab-modal-overlay">
      <div className="material-tab-modal">
        <h3>Upload Bill for <span style={{ fontWeight: 600 }}>{material.name || 'Material'}</span></h3>


        {!isSkipQuantity && (
          <input
            type="number"
            placeholder="Quantity"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            min={1}
          />
        )}
        {isSkipQuantity && (
          <input
            type="number"
            value={quantity}
            readOnly
            disabled
            style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
          />
        )}


        <input
          type="number"
          placeholder="Amount ₹"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          min={1}
        />

        <input
          type="file"
          accept=".pdf,image/*"
          onChange={(e) => setFile(e.target.files[0])}
        />

        <div className="material-tab-footer">
          <button className="btn black" onClick={handleSubmit} disabled={submitting || !isFormValid()}>

            {submitting ? 'Uploading…' : 'Upload'}
          </button>
          <button className="btn cancel" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default UploadBillModal;
